import type { UserData } from '../types/UserData';
import {SUBSCRIPTION_HEALTH,type SubscriptionHealthType
} from '../constants/subscriptionHealth';
import {getSubscriptionStatus} from './subscriptionUtils';
import {SUBSCRIPTION_STATUS} from '../constants/subscriptionStatus';
import {ACCOUNT_STATUS} from '../constants/accountStatus';

export function getSubscriptionHealth(
user: UserData
): SubscriptionHealthType {

    if (
  user.accountStatus ===
  ACCOUNT_STATUS.BLOCKED
) {
  return SUBSCRIPTION_HEALTH.BLOCKED;
}

if (
  user.accountStatus ===
  ACCOUNT_STATUS.SUSPENDED
) {
  return SUBSCRIPTION_HEALTH.SUSPENDED;
}

if (
  user.accountStatus ===
  ACCOUNT_STATUS.PENDING
) {
  return SUBSCRIPTION_HEALTH.PENDING;
}

const subscriptionStatus =
  getSubscriptionStatus(
    user.subscriptionExpiresAt
  );

 if (
  subscriptionStatus ===
  SUBSCRIPTION_STATUS.VALID
) {
  return SUBSCRIPTION_HEALTH.HEALTHY;
}

if (
  subscriptionStatus ===
  SUBSCRIPTION_STATUS.EXPIRING_SOON
) {
  return SUBSCRIPTION_HEALTH.WARNING;
}

if (
  subscriptionStatus ===
  SUBSCRIPTION_STATUS.EXPIRED
) {
  return SUBSCRIPTION_HEALTH.EXPIRED;
}

return SUBSCRIPTION_HEALTH.EXPIRED;
}